/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-10 17:22:52
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:46:49
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/LinkImg/index.tsx
 */
/**
 *  Link and Image
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-10 17:22:52
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-24 15:17:53
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/LinkImg/index.tsx
 */
/**
 *  Link and Image
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import LinkLibrary from 'src/constrains/LinkLibrary';
// import DeleteButton from 'src/components/Buttons/DeleteButton';
// import { Uploader } from 'src/components/Upload';
import { errCodesMap } from '@/src/error/code';
import DraggableImageDisplay from 'src/components/DragRowDisplay/Image';

import classNames from 'classnames';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';

// import _ from 'lodash';

const LinkImage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    title,
    subtitle,
    onDelete,
    linkOnChange,
    imgOnChange,
    linkImage,
    linkId,
    //To Do Delete Link Temp
    linkSet,
    link,
    imageErrorArray = [],
    linkTypeErrorArray = [],
    showImageDisplaySetting,
    disabled,
    hideEdit,
  } = props;
  // console.log('link image linkSet', linkSet);

  //const [fileList, setFileList] = React.useState(linkImage ? [linkImage] : []);
  return (
    <div className={css.container}>
      <Section
        className={classNames(css.section, {
          [css.paddingBottom]: showImageDisplaySetting,
        })}>
        <DraggableImageDisplay
          error={imageErrorArray.join(' ')}
          title={title}
          subtitle={subtitle}
          onDelete={onDelete}
          imgOnChange={imgOnChange}
          linkImage={linkImage}
          //showImageDisplaySetting={showImageDisplaySetting}
          disabled={disabled}
          hideEdit={hideEdit}
        />

        {!showImageDisplaySetting && (
          <div className={css.linkContainer}>
            <LinkLibrary
              customTitle={`${getI18n('general.linkModule.Modal.link')}*`}
              error={linkTypeErrorArray
                .map((err) => (errCodesMap[err] ? errCodesMap[err] : err))
                .join('')}
              data={link}
              onChange={linkOnChange}
              id={linkId}
              linkSet={linkSet}
              disabled={disabled}
            />
          </div>
        )}
      </Section>
    </div>
  );
};
export default LinkImage;
